import Button from '@/components/Button';
import ModalHoc from '@/components/ModalHoc';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const ConfirmationModal = _ref => {
  let {
    onClose,
    onConfirm
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.message,
      children: [/*#__PURE__*/_jsx("div", {
        children: "Any changes you have made will be lost and replaced by the current spreadsheet in Google Drive."
      }), /*#__PURE__*/_jsx("div", {
        children: "Are you sure you want to proceed?"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [/*#__PURE__*/_jsx(Button, {
        variant: 'gray',
        onClick: () => onClose(false),
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onConfirm,
        children: "Confirm"
      })]
    })]
  });
};

export default ModalHoc(ConfirmationModal, {
  modalClass: styles.modal,
  overlayclass: styles.overlay,
  closeButtonClass: styles.close,
  indexable: true
});